import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { store, persistor } from './store';
import AppRoutes from './routes/AppRoutes';
import Toast from './components/Toast/Toast';
import { theme } from './theme/theme';
import './styles/main.scss';

const App: React.FC = () => {
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
  const isValidGoogleClientId = googleClientId &&
    !googleClientId.includes('your-google-client-id') &&
    googleClientId.includes('.apps.googleusercontent.com');

  // Use a dummy client ID if not configured to prevent errors
  // The Login/Signup pages will show a warning when OAuth is not configured
  const clientIdToUse = isValidGoogleClientId ? googleClientId : 'dummy-client-id.apps.googleusercontent.com';

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <GoogleOAuthProvider clientId={clientIdToUse}>
            <AppRoutes />
            <Toast />
          </GoogleOAuthProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
